var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhotos = function SvgPhotos(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.2 2.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8 15.8H2.8C1.695 15.8 0.8 14.905 0.8 13.8V2.8C0.8 1.695 1.695 0.8 2.8 0.8H15.8C16.905 0.8 17.8 1.695 17.8 2.8V13.8C17.8 14.905 16.905 15.8 15.8 15.8Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.2 7.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.796 13.401H2.8C1.695 13.401 0.8 12.506 0.8 11.401V0.8",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.7 5.53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.64574 1.28825C4.29675 1.93926 4.29675 2.99474 3.64574 3.64574C2.99474 4.29675 1.93925 4.29675 1.28825 3.64574C0.637249 2.99474 0.637249 1.93925 1.28825 1.28825C1.93926 0.637249 2.99474 0.637249 3.64574 1.28825Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.2 10.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8 3.72818L12.414 1.01918C11.983 0.674184 11.353 0.744184 11.008 1.17518L8.43602 4.39018C8.09102 4.82118 7.46202 4.89118 7.03002 4.54618L5.73102 3.50718C5.30602 3.16718 4.68702 3.22918 4.33802 3.64818L0.80002 7.89518",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhotos);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "20bcb3fdf925becb391ebce0ff1b3784.svg";